export default "__VITE_ASSET__Chr9vrtD__"